import gql from 'graphql-tag';

export const GET_COSTCO_MEMBERSHIP_EXPERIMENT_METRICS = gql`
  query getCostcoMembershipExperimentMetrics($params: ReportInput!) {
    costcoMembershipExperimentMetrics(params: $params) {
      day
      sales
      totalMemberships
      execOfferBase
      execOfferA
      execOfferB
      goldOfferBase
      goldOfferA
      goldOfferB
      outOfExperiment
      cashbackAmount
      campaignFeeAmount
      marketingFeeAmount
    }
  }
`;

export default GET_COSTCO_MEMBERSHIP_EXPERIMENT_METRICS;
